export const SUBSCRIPTION_STATUSES = {
	ACTIVE: 'active',
	CANCELED: 'canceled',
	CANCELLED: 'cancelled',
	PAUSED: 'paused',
	SUSPENDED: 'suspended',
	PENDING: 'pending',
	EXPIRED: 'expired',
};

export const SUBSCRIPTION_PLANS = {
	FREE: 'free',
	STARTER: 'starter',
	PRO: 'pro',
	BUSINESS: 'business',
	ENTERPRISE: 'enterprise',
};
